export default {
  menuList: [
    {
      name: 'Dashboard',
      displayName: 'menu.dashboard',
      icon: 'fa-solid fa-chart-column',
      route: '/dashboard',
      allow: ['COMPANY', 'SUBCOMPANY', 'SUPERADMIN', 'AGENT', 'SUBAGENT', 'ADMIN']
    },
    {
      name: 'Account',
      displayName: 'menu.account',
      icon: 'fa-regular fa-user',
      allow: ['COMPANY', 'SUBCOMPANY', 'SUPERADMIN', 'AGENT', 'SUBAGENT', 'ADMIN'],
      child: [
        {
          name: 'Profile',
          displayName: 'menu.profile',
          shortName: 'PF',
          route: '/profile',
          parentName: 'Account',
          allow: ['COMPANY', 'SUBCOMPANY', 'SUPERADMIN', 'AGENT', 'SUBAGENT', 'ADMIN']
        },
        {
          name: 'Password',
          displayName: 'menu.password',
          shortName: 'PW',
          route: '/password',
          parentName: 'Account',
          allow: ['COMPANY', 'SUBCOMPANY', 'SUPERADMIN', 'AGENT', 'SUBAGENT', 'ADMIN']
        }
      ]
    },
    {
      name: 'Member',
      key: 'member',
      displayName: 'menu.memberManagement',
      icon: 'fa-regular fa-user',
      allow: ['COMPANY', 'SUBCOMPANY', 'SUPERADMIN', 'AGENT', 'SUBAGENT', 'ADMIN'],
      child: [
        // {
        //   name: 'Create Account',
        //   displayName: 'menu.createMember',
        //   shortName: 'CA',
        //   route: '/createaccount',
        //   parentName: 'Member',
        // },
        {
          name: 'Add Agent',
          displayName: 'menu.addAgent',
          shortName: 'AA',
          route: '/add-agent',
          parentName: 'Member',
          allow: [
            'COMPANY',
            'SUBCOMPANY',
            'AGENT'
            // 'SUBAGENT',
          ],
          isEditPermKey: 'member'
          // parentName: ['Member', 'Downline'],
        },
        {
          name: 'Add Member',
          displayName: 'menu.addMember',
          shortName: 'AM',
          route: '/add-member',
          parentName: 'Member',
          allow: ['AGENT'],
          isEditPermKey: 'member'
          // parentName: ['Member', 'Downline'],
        },
        {
          name: 'Downline',
          displayName: 'menu.memberDownlineList',
          shortName: 'DL',
          route: '/downline',
          parentName: 'Member',
          allow: ['COMPANY', 'SUBCOMPANY', 'SUPERADMIN', 'AGENT', 'SUBAGENT', 'ADMIN']
        },
        {
          name: 'Add Sub Account',
          displayName: 'menu.addSubAccount',
          shortName: 'ASA',
          route: '/add-subaccount',
          parentName: 'Member',
          allow: ['COMPANY', 'AGENT']
          // parentName: ['Member', 'Sub Accounts'],
        },
        {
          name: 'Sub Accounts',
          displayName: 'menu.subAccount',
          shortName: 'SA',
          route: '/subaccount',
          parentName: 'Member',
          allow: ['COMPANY', 'AGENT']
        }
      ]
    },
    {
      name: 'Report',
      key: 'report',
      displayName: 'menu.report',
      icon: 'fa-regular fa-file-lines',
      allow: ['COMPANY', 'SUBCOMPANY', 'SUPERADMIN', 'AGENT', 'SUBAGENT', 'ADMIN'],
      child: [
        {
          name: 'W/L Member',
          displayName: 'menu.winloseSimple',
          shortName: 'WL',
          route: '/winlosemember',
          parentName: 'Report',
          allow: ['COMPANY', 'SUBCOMPANY', 'SUPERADMIN', 'AGENT', 'SUBAGENT', 'ADMIN']
        },
        {
          name: 'W/L Member (Mechanic)',
          displayName: 'menu.winloseMechanic',
          shortName: 'WLM',
          route: '/winlosemechanic',
          parentName: 'Report',
          allow: ['COMPANY', 'SUBCOMPANY', 'SUPERADMIN', 'AGENT', 'SUBAGENT', 'ADMIN'],
          isEditPermKey: 'reportMechanic',
          isEdit: true
        },
        {
          name: 'Game Report',
          displayName: 'menu.gameReport',
          shortName: 'GR',
          route: '/game-report',
          parentName: 'Report',
          allow: ['COMPANY', 'SUBCOMPANY', 'SUPERADMIN', 'AGENT'],
          level: 1
        },
        {
          name: 'High Value Report',
          displayName: 'menu.highValueReport',
          shortName: 'HVR',
          route: '/high-value-report',
          parentName: 'Report',
          allow: ['SUBCOMPANY', 'ADMIN', 'SUPERADMIN'],
          level: 1
        },
        {
          name: 'Mechanic Report',
          displayName: 'menu.mechanicReport',
          shortName: 'MR',
          route: '/mechanic-report',
          parentName: 'Report',
          allow: [
            'COMPANY',
            'SUBCOMPANY',
            'SUPERADMIN'
            // 'AGENT',
          ],
          level: 1
        },
        {
          name: 'Legend of dolly',
          displayName: 'menu.legend_of_dolly',
          icon: 'far fa-report',
          route: '/legend-of-dolly',
          parentName: 'Report',
          allow: ['SUBCOMPANY', 'SUPERADMIN']
        },
        {
          name: 'Game Analytics',
          displayName: 'menu.gameAnalytics',
          icon: 'far fa-report',
          route: '/game-analytics',
          parentName: 'Report',
          allow: ['SUBCOMPANY', 'SUPERADMIN', 'ADMIN']
        }
        // {
        //   name: 'Provider Report',
        //   displayName: 'menu.providerReport',
        //   shortName: 'PR',
        //   route: '/provider-report',
        //   parentName: 'Report',
        //   allow: [
        //     'COMPANY',
        //     'SUPERADMIN',
        //   ],
        // },
      ]
    },
    {
      name: 'Payment',
      key: 'statement',
      displayName: 'menu.payment',
      icon: 'fa-solid fa-file-invoice-dollar',
      allow: ['COMPANY', 'SUBCOMPANY', 'SUPERADMIN', 'AGENT', 'SUBAGENT', 'ADMIN'],
      child: [
        {
          name: 'Deposit Withdraw',
          displayName: 'menu.depositWithdraw',
          shortName: 'DW',
          route: '/deposit-withdraw',
          parentName: 'Payment',
          allow: ['COMPANY', 'SUBCOMPANY', 'SUPERADMIN', 'AGENT', 'SUBAGENT', 'ADMIN']
        }
        // {
        //   name: 'Statement',
        //   displayName: 'menu.statement',
        //   shortName: 'ST',
        //   route: '/statement',
        //   parentName: 'Payment',
        // },
      ]
    },
    {
      name: 'Announcements',
      displayName: 'menu.announce',
      icon: 'fa-solid fa-bullhorn',
      allow: ['COMPANY', 'SUBCOMPANY', 'SUPERADMIN', 'ADMIN'],
      child: [
        {
          name: 'Message',
          displayName: 'menu.message',
          shortName: 'MS',
          route: '/message',
          parentName: 'Announcements',
          allow: ['COMPANY', 'SUBCOMPANY', 'SUPERADMIN', 'ADMIN']
        },
        {
          name: 'Banner',
          displayName: 'menu.banner',
          shortName: 'BN',
          route: '/banner',
          parentName: 'Announcements',
          allow: ['COMPANY', 'SUBCOMPANY', 'SUPERADMIN', 'ADMIN']
        }
      ]
    },
    // {
    //   name: 'Seamless',
    //   key: 'seamless',
    //   displayName: 'menu.seamless',
    //   icon: 'far fa-report',
    //   allow: [
    //     'COMPANY',
    // 'SUBCOMPANY',
    //     'SUPERADMIN',
    //     'AGENT',
    //     'SUBAGENT',
    //   ],
    //   child: [
    //     {
    //       name: 'Bet',
    //       displayName: 'menu.bet',
    //       shortName: 'BT',
    //       route: '/bet',
    //       parentName: 'Seamless',
    //       allow: [
    //         'COMPANY',
    // 'SUBCOMPANY',
    //         'SUPERADMIN',
    //         'AGENT',
    //         'SUBAGENT',
    //       ],
    //     },
    //     {
    //       name: 'Bet Cancel',
    //       displayName: 'menu.betCancel',
    //       shortName: 'BC',
    //       route: '/bet-cancel',
    //       parentName: 'Seamless',
    //       allow: [
    //         'COMPANY',
    // 'SUBCOMPANY',
    //         'SUPERADMIN',
    //         'AGENT',
    //         'SUBAGENT',
    //       ],
    //     },
    //     {
    //       name: 'Payout',
    //       displayName: 'menu.payout',
    //       shortName: 'PO',
    //       route: '/payout',
    //       parentName: 'Seamless',
    //       allow: [
    //         'COMPANY',
    // 'SUBCOMPANY',
    //         'SUPERADMIN',
    //         'AGENT',
    //         'SUBAGENT',
    //       ],
    //     },
    //     {
    //       name: 'Recal',
    //       displayName: 'menu.recal',
    //       shortName: 'RC',
    //       route: '/recal',
    //       parentName: 'Seamless',
    //       allow: [
    //         'COMPANY',
    // 'SUBCOMPANY',
    //         'SUPERADMIN',
    //         'AGENT',
    //         'SUBAGENT',
    //       ],
    //     },
    //   ],
    // },
    {
      name: 'User Online',
      key: 'useronline',
      displayName: 'menu.useronline',
      icon: 'fa-solid fa-chart-column',
      route: '/useronline',
      allow: ['COMPANY', 'SUBCOMPANY', 'SUPERADMIN', 'ADMIN', 'AGENT', 'SUBAGENT']
    },
    {
      name: 'Suggest',
      key: 'suggestion',
      displayName: 'menu.suggest',
      icon: 'fa-regular fa-lightbulb',
      allow: ['COMPANY', 'SUBCOMPANY', 'SUPERADMIN', 'SUBACCOUNT', 'AGENT', 'SUBAGENT', 'ADMIN'],
      child: [
        {
          name: 'Suggest Member',
          displayName: 'menu.suggest_member',
          shortName: 'SM',
          route: '/suggest-member',
          parentName: 'Suggest',
          allow: ['COMPANY', 'SUBCOMPANY', 'SUBACCOUNT', 'SUPERADMIN', 'AGENT', 'SUBAGENT', 'ADMIN']
        }
      ]
    },
    {
      name: 'API Key',
      key: 'apikey',
      displayName: 'menu.apiKey',
      icon: 'fa-solid fa-key',
      allow: ['SUPERADMIN', 'AGENT', 'SUBAGENT', 'ADMIN'],
      child: [
        {
          name: 'Seamless Key',
          displayName: 'menu.seamlessKey',
          shortName: 'SK',
          route: '/seamless-key',
          parentName: 'API Key',
          allow: ['SUPERADMIN', 'AGENT', 'SUBAGENT', 'ADMIN']
        },
        {
          name: 'Transfer Key',
          displayName: 'menu.transferKey',
          shortName: 'TK',
          route: '/transfer-key',
          parentName: 'API Key',
          allow: ['SUPERADMIN', 'AGENT', 'SUBAGENT', 'ADMIN']
        },
        {
          name: 'Document',
          displayName: 'menu.documentapi',
          shortName: 'DC',
          route: '/documentapi',
          parentName: 'API Key',
          allow: ['SUPERADMIN', 'AGENT', 'SUBAGENT', 'ADMIN']
        }
      ]
    },
    {
      // name: 'Social',
      // key: 'social',
      // displayName: 'menu.social',
      // route: '/social',
      // icon: 'far fa-report',
      // allow: [
      //   'SUPERADMIN',
      //   'AGENT',
      //   'SUBAGENT',
      //   'ADMIN',
      // ],
      // child: [
      //   {
      //     name: 'Seamless Key',
      //     displayName: 'menu.seamlessKey',
      //     shortName: 'SK',
      //     route: '/seamless-key',
      //     parentName: 'API Key',
      //     allow: [
      //       'SUPERADMIN',
      //       'AGENT',
      //       'SUBAGENT',
      //     ],
      //   },
      //   {
      //     name: 'Transfer Key',
      //     displayName: 'menu.transferKey',
      //     shortName: 'TK',
      //     route: '/transfer-key',
      //     parentName: 'API Key',
      //     allow: [
      //       'SUPERADMIN',
      //       'AGENT',
      //       'SUBAGENT',
      //     ],
      //   },
      // ],
    },
    {
      name: 'Marketing',
      displayName: 'menu.marketing',
      icon: 'fa-solid fa-chart-line',
      allow: ['COMPANY', 'SUPERADMIN', 'SUBCOMPANY', 'AGENT', 'ADMIN', 'SUPERADMIN', 'SUBAGENT'],
      child: [
        {
          name: 'Social',
          displayName: 'menu.social',
          shortName: 'SC',
          route: '/social',
          parentName: 'Marketing',
          allow: ['AGENT', 'SUBAGENT']
        },
        // {
        //   name: 'Promotion',
        //   displayName: 'menu.promotion',
        //   shortName: 'PM',
        //   route: '/promotion',
        //   parentName: 'Marketing',
        //   allow: [
        //     'AGENT',
        //     'SUBAGENT',
        //   ],
        // },
        // {
        //   name: 'Document',
        //   displayName: 'menu.documentapi',
        //   shortName: 'DC',
        //   route: '/documentapi',
        //   parentName: 'Marketing',
        //   allow: [
        //     'AGENT',
        //     'ADMIN',
        //     'SUPERADMIN',
        //     'SUBAGENT',
        //   ],
        // },
        {
          name: 'Feature',
          displayName: 'menu.feature',
          shortName: 'ft',
          route: '/feature',
          parentName: 'Marketing',
          allow: ['COMPANY', 'SUBCOMPANY', 'AGENT', 'SUPERADMIN', 'ADMIN']
        },
        {
          name: 'Mascot',
          displayName: 'menu.mascot',
          shortName: 'ft',
          route: '/mascot',
          parentName: 'Marketing',
          allow: ['SUPERADMIN', 'ADMIN']
        },
        {
          name: 'Angpow',
          displayName: 'menu.angpow',
          shortName: 'agp',
          route: '/angpow',
          parentName: 'Marketing',
          allow: ['SUPERADMIN', 'ADMIN']
        },
        {
          name: 'Campaign',
          displayName: 'menu.campaign',
          shortName: 'cp',
          route: '/campaign',
          parentName: 'Marketing',
          allow: ['SUPERADMIN']
        }
      ]
    },
    {
      name: 'Finance',
      displayName: 'menu.finance',
      icon: 'fa-solid fa-file-invoice-dollar',
      allow: ['COMPANY', 'SUBCOMPANY', 'SUPERADMIN', 'SUBCOMPANY', 'AGENT', 'SUBAGENT'],
      child: [
        // {
        //   name: 'Bank Account',
        //   displayName: 'menu.bankAccount',
        //   shortName: 'BA',
        //   route: '/bank-account',
        //   parentName: 'Finance',
        //   allow: [
        //     'SUPERADMIN',
        //     'SUBCOMPANY',
        //   ],
        // },
        {
          name: 'Invoice',
          displayName: 'menu.invoice',
          shortName: 'IV',
          route: '/invoice',
          parentName: 'Finance',
          allow: ['SUPERADMIN', 'SUBCOMPANY']
        },
        {
          name: 'Currency',
          displayName: 'menu.currency',
          shortName: 'CY',
          route: '/ratecurrency',
          parentName: 'Finance',
          allow: ['ADMIN', 'SUPERADMIN', 'COMPANY', 'SUBCOMPANY', 'AGENT', 'SUBAGENT']
        }
      ]
    },
    // {
    //   name: 'Activity',
    //   displayName: 'menu.activity',
    //   icon: 'fas fa-member',
    //   route: '/active-agent',
    //   allow: [
    //     'AGENT',
    //     'SUBACCOUNT',
    //     'SUBAGENT',
    //   ],
    // },
    {
      name: 'Point',
      key: 'point',
      displayName: 'menu.point',
      icon: 'fa-solid fa-star',
      allow: ['COMPANY', 'SUBCOMPANY', 'SUPERADMIN', 'ADMIN', 'AGENT', 'SUBACCOUNT', 'SUBAGENT'],
      child: [
        {
          name: 'Point',
          displayName: 'menu.point',
          icon: 'far fa-report',
          route: '/point',
          parentName: 'Point',
          allow: ['COMPANY', 'SUBCOMPANY', 'SUPERADMIN', 'ADMIN', 'AGENT', 'SUBACCOUNT', 'SUBAGENT']
        }
      ]
    },
    {
      name: 'INVITEFRIEND',
      key: 'inviteFriend',
      displayName: 'menu.inviteFriend',
      icon: 'fa-solid fa-user-plus',
      allow: ['COMPANY', 'SUBCOMPANY', 'SUPERADMIN', 'ADMIN', 'AGENT', 'SUBACCOUNT', 'SUBAGENT'],
      child: [
        {
          name: 'Coin',
          displayName: 'menu.coin',
          icon: 'far fa-report',
          route: '/coin',
          parentName: 'INVITEFRIEND',
          allow: ['COMPANY', 'SUBCOMPANY', 'SUPERADMIN', 'ADMIN', 'AGENT', 'SUBACCOUNT', 'SUBAGENT']
        },
        {
          name: 'URL',
          displayName: 'menu.url',
          icon: 'far fa-report',
          route: '/url',
          parentName: 'INVITEFRIEND',
          allow: ['COMPANY', 'SUBCOMPANY', 'SUPERADMIN', 'ADMIN', 'AGENT', 'SUBACCOUNT', 'SUBAGENT']
        }
      ]
    },
    {
      name: 'ADMIN',
      key: 'admin',
      displayName: 'menu.adminmanagement',
      icon: 'fa-solid fa-user-gear',
      allow: ['SUPERADMIN', 'ADMIN'],
      child: [
        {
          name: 'Game Maintenance',
          displayName: 'menu.maintenance',
          shortName: 'GV',
          route: '/game-version',
          parentName: 'ADMIN',
          allow: ['SUPERADMIN', 'ADMIN']
        },
        {
          name: 'Pattern Maintenance',
          displayName: 'menu.maintenance_pattern',
          shortName: 'PV',
          route: '/pattern-version',
          parentName: 'ADMIN',
          allow: ['SUPERADMIN', 'ADMIN']
        },
        {
          name: 'Game Version Control',
          displayName: 'menu.versioncontrol',
          shortName: 'GT',
          route: '/game-version-control',
          parentName: 'ADMIN',
          allow: ['SUPERADMIN', 'ADMIN']
        },
        {
          name: 'Reset Password Log',
          displayName: 'menu.resetpasslog',
          shortName: 'RP',
          route: '/reset-passlog',
          parentName: 'ADMIN',
          allow: ['SUPERADMIN', 'ADMIN']
        },
        {
          name: 'Update Commission Log',
          displayName: 'menu.updatecommissionlog',
          shortName: 'UC',
          route: '/update-commission-log',
          parentName: 'ADMIN',
          allow: ['SUPERADMIN', 'ADMIN']
        },
        {
          name: 'Secret Password',
          displayName: 'menu.secretpass',
          shortName: 'SC',
          route: '/secret-password',
          parentName: 'ADMIN',
          allow: ['SUPERADMIN', 'ADMIN']
        },
        {
          name: 'Activity',
          displayName: 'menu.activity',
          shortName: 'AT',
          route: '/activity',
          parentName: 'ADMIN',
          allow: ['SUPERADMIN', 'ADMIN']
        },
        {
          name: 'User Seamless',
          displayName: 'menu.user_seamless_problem',
          shortName: 'USP',
          route: '/user-seamless-problem',
          parentName: 'ADMIN',
          allow: ['SUPERADMIN', 'ADMIN']
        },
        {
          name: 'Demo URL',
          displayName: 'menu.demo',
          shortName: 'DU',
          route: '/demo-url',
          parentName: 'ADMIN',
          allow: ['SUPERADMIN', 'ADMIN']
        },
        {
          name: 'LogAdmin',
          displayName: 'menu.logAdmin',
          shortName: 'LA',
          route: '/log-admin',
          parentName: 'ADMIN',
          allow: ['SUPERADMIN', 'ADMIN']
        },
        {
          name: 'User',
          displayName: 'menu.user',
          shortName: 'US',
          route: '/user',
          parentName: 'ADMIN',
          allow: ['SUPERADMIN', 'ADMIN']
        },
        {
          name: 'RTP Management',
          displayName: 'menu.rtpmanagement',
          shortName: 'RM',
          route: '/rtp-management',
          parentName: 'ADMIN',
          allow: ['SUPERADMIN']
        },
        {
          name: 'RTP Agent Management',
          displayName: 'menu.rtpagentmanagement',
          shortName: 'RMA',
          route: '/rtp-agent-management',
          parentName: 'ADMIN',
          allow: ['SUPERADMIN']
        },
        {
          name: 'Risk Management',
          displayName: 'menu.riskmanagement',
          shortName: 'RM',
          route: '/rtp-riskmanagement',
          parentName: 'ADMIN',
          allow: ['SUPERADMIN']
        },
        {
          name: 'Domain Pool',
          displayName: 'menu.domainPool',
          shortName: 'dmp',
          route: '/domain-pool',
          parentName: 'ADMIN',
          allow: ['SUPERADMIN', 'ADMIN']
        }
      ]
    },
    {
      name: 'Logs',
      displayName: 'menu.logs',
      icon: 'fa-solid fa-clock-rotate-left',
      allow: ['COMPANY', 'AGENT', 'SUBACCOUNT', 'SUBCOMPANY', 'SUBAGENT'],
      child: [
        {
          name: 'Access Logs',
          displayName: 'menu.accessLogs',
          icon: 'fas fa-member',
          shortName: 'AC',
          route: '/access-logs',
          parentName: 'Logs',
          allow: ['COMPANY', 'AGENT', 'SUBCOMPANY', 'SUBACCOUNT', 'SUBAGENT']
        },
        {
          name: 'Payment Logs',
          displayName: 'menu.paymentlog',
          icon: 'fas fa-member',
          shortName: 'AC',
          route: '/paymentlog',
          parentName: 'Logs',
          allow: ['COMPANY', 'AGENT', 'SUBCOMPANY', 'SUBACCOUNT', 'SUBAGENT']
        }
      ]
    },
    {
      name: 'SETTING',
      key: 'setting',
      displayName: 'menu.setting',
      icon: 'fa-solid fa-gear',
      allow: ['SUPERADMIN', 'COMPANY', 'SUBCOMPANY', 'AGENT'],
      child: [
        {
          name: 'Back Office',
          displayName: 'menu.bo',
          shortName: 'BO',
          route: '/backoffice',
          parentName: 'SETTING',
          allow: ['SUPERADMIN', 'COMPANY', 'SUBCOMPANY']
        },
        {
          name: 'Agent Setting',
          displayName: 'menu.agentSetting',
          shortName: 'WL',
          route: '/agentsetting',
          parentName: 'SETTING',
          isWhiteLabel: true,
          allow: ['AGENT']
        },
        {
          name: 'Landing Page Setting',
          displayName: 'menu.landingPageSetting',
          shortName: 'WL',
          route: '/landingpagesetting',
          parentName: 'SETTING',
          isWhiteLabel: true,
          allow: ['AGENT']
        },
        {
          name: 'Theme Selection',
          displayName: 'menu.themeSelection',
          shortName: 'WL',
          route: '/themeselection',
          parentName: 'SETTING',
          isWhiteLabel: true,
          allow: ['AGENT']
        },
        {
          name: 'Lobby',
          displayName: 'menu.lobby',
          shortName: 'LB',
          route: '/lobby',
          parentName: 'SETTING',
          allow: ['SUPERADMIN', 'COMPANY', 'SUBCOMPANY']
        }
      ]
    }
  ]
};
